import { createTheme } from "@mui/material";

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#d1c4e9",
    },
    secondary: {
      main: "#ef9a9a",
    },
  },
});

export default defaultTheme;
